<template>
  <v-layout class="carousel-wrapper">
    <v-btn
      v-if="overflowInPx > 0"
      :disabled="moveLeftArrowDisabled"
      flat
      icon
      @click="() => moveLeft()"
    >
      <v-icon>keyboard_arrow_left</v-icon>
    </v-btn>
    <div class="carousel pt-1">
      <div ref="inner" class="carousel-inner" :style="innerStyles">
        <slot />
      </div>
    </div>
    <v-btn
      v-if="overflowInPx > 0"
      :disabled="moveRightArrowDisabled"
      flat
      icon
      @click="() => moveRight()"
    >
      <v-icon>keyboard_arrow_right</v-icon>
    </v-btn>
  </v-layout>
</template>

<script>
export default {
  name: 'Carousel',
  data() {
    return {
      innerStyles: {},
      transitioning: false,
      translateX: 0,
      firstVisibleChildIndex: 0,
      overflowInPx: 0,
    };
  },
  computed: {
    moveRightArrowDisabled() {
      return this.transitioning || this.firstVisibleChildIndex < 1;
    },
    moveLeftArrowDisabled() {
      return this.transitioning || this.overflowInPx < this.translateX;
    },
  },
  methods: {
    recalculateOverflow() {
      this.$nextTick(() => {
        this.overflowInPx = [...this.$refs.inner.children].reduce((a, b) => a + b.offsetWidth, 0) - this.$refs.inner.offsetWidth;
      });
    },
    moveRight() {
      if (this.transitioning) return;

      this.transitioning = true;
      this.translateX = this.translateX - this.$refs.inner.children[this.firstVisibleChildIndex - 1].offsetWidth;
      this.firstVisibleChildIndex--;
      this.innerStyles = {
        transform: `translateX(${this.translateX}px)`,
        transition: '0.5s',
      };

      this.afterTransition(() => {
        this.resetTranslate();
        this.transitioning = false;
      });
    },
    moveLeft() {
      if (this.transitioning) return;

      this.transitioning = true;
      this.translateX = this.translateX + this.$refs.inner.children[this.firstVisibleChildIndex].offsetWidth;
      this.firstVisibleChildIndex++;
      this.innerStyles = {
        transform: `translateX(${this.translateX}px)`,
        transition: '0.5s',
      };

      this.afterTransition(() => {
        this.resetTranslate();
        this.transitioning = false;
      });
    },
    afterTransition(callback) {
      const listener = () => {
        callback();
        this.$refs.inner.removeEventListener('transitionend', listener);
      };
      this.$refs.inner.addEventListener('transitionend', listener);
    },
    resetTranslate() {
      this.innerStyles = {
        transform: `translateX(${this.translateX}px)`,
        transition: 'none',
      };
    },
  },
};
</script>

<style>
.carousel {
  overflow: hidden;
  margin-left: auto;
}

.carousel-wrapper {
  display: flex;
}

.carousel-inner {
  white-space: nowrap;
  display: flex;
  justify-content: end;
  flex-direction: row-reverse;
}
</style>
